<h1 mat-dialog-title>Dialog</h1>
<div mat-dialog-content>
  <p>{{data.message | translate}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No</button>
  <button mat-button (click)="onYesClick()">Yes</button>
</div>
